import Leaderboard from './leaderboard';

export default Leaderboard;
